import util from './_utils';
import love_hate_steps from './love-hate-steps';
import love_hate_ from './love-hate';
import header from './header';
import landing from './landing';
import core_viz from './core-viz';
import comm from './community';
import comm_bars from './community-bars';
import routine_ from './routine';
import aspirations_ from './aspirations';
import health_globe from './health-globe';
import graphic from './graphic';
import track from './track';
import filters from './filters';

const menu = d3.selectAll('.chapter-select');

const about = menu.select('.about'),
	love_hate = menu.select('.love-hate'),
	core_motivations = menu.select('.core-motivations'),
	health = menu.select('.health'),
	routine = menu.select('.routine'),
	community = menu.select('.community'),
	aspirations = menu.select('.aspiration'),
	backToCV = d3.selectAll('.dir-back-cv');

function init() {
	about.on('click', () => header.toggleAbout(true));

	love_hate.on('click', () => {
		header.toggleMenu(false);

		if (checkChapterChange('love-hate')) {
			chapterChange('love-hate');
		}
	});

	backToCV.on('click', () => {
		header.toggleMenu(false);

		if (checkChapterChange('core-viz')) {
			chapterChange('core-viz');
		}
	})

	core_motivations.on('click', () => {
		header.toggleMenu(false);

		if (checkChapterChange('core-viz')) {
			chapterChange('core-viz');
		}
	})

	health.on('click', () => {
		header.toggleMenu(false);

		if (checkChapterChange('health')) {
			chapterChange('health');
		}
	})

	routine.on('click', () => {
		header.toggleMenu(false);

		if (checkChapterChange('routine')) {
			chapterChange('routine');
		}
	})

	community.on('click', () => {
		header.toggleMenu(false);

		if (checkChapterChange('community')) {
			chapterChange('community');
		}
	})

	aspirations.on('click', () => {
		header.toggleMenu(false);

		if (checkChapterChange('aspirations')) {
			chapterChange('aspirations');
		}
	})
}

function chapterChange(chapter) {
	$('.graphic').unbind('scroll');
	$('.graphic').unbind('mousewheel');

	if (util.getStoryLocation().current_chapter === 'landing') landing.skip();
	if (util.getStoryLocation().current_chapter === 'love-hate') love_hate_steps.end();

	if (chapter === 'love-hate') {
		util.transitionViz('love-hate');
		graphic.updateGraphicContent('love-hate');

		d3.selectAll('.skip-intro').classed('is-adjusted', true);
		d3.select('.bottom-ui--ready').classed('is-visible', true);
		d3.select('.bottom-ui--start').classed('is-visible', false);

		landing.jumpTo(4, true);
		track.init();
		love_hate_.next(-1);

		// core_viz.clearMass();

		util.changeHeader('.main-header', '.landing-header');
		util.changeVisibility(['.graphic__right', '.skip-intro'], [false, true]);
		// love_hate_.end();
		//
		// track.init();
		// love_hate_.next(-1);
		// love_hate_steps.end();
		// d3.selectAll('.skip-intro').classed('is-adjusted', true);
		// d3.select('.bottom-ui--ready').classed('is-visible', true);
		// d3.select('.bottom-ui--start').classed('is-visible', false);
		// track.next(-1);
		// landing.jumpTo(4, true);
		//



		// //no show chapter for love-hate, so have to set
		// util.setStoryLocation('love-hate');
		filters.toggle('love-hate', -1);

		$('.graphic').bind('scroll', function(evt) {
			landing.next(4);
		}).bind('mousewheel', function(evt) {
			landing.next(4);
		});
	}

	if (chapter === 'core-viz') {
		util.changeHeader('.landing-header', '.main-header');
		util.transitionViz('core-viz');
		util.showChapter('core-viz');
		filters.toggle('core-viz', -1);
	}

	if (chapter === 'health') {
		util.changeHeader('.landing-header', '.main-header');
		util.transitionViz('health');
		util.showChapter('health');
		filters.toggle('health', -1);
	}

	if (chapter === 'routine') {
		util.changeHeader('.landing-header', '.main-header');
		util.transitionViz('routine');
		util.showChapter('routine');
		filters.toggle('routine', -1);
	}

	if (chapter === 'community') {
		util.changeHeader('.landing-header', '.main-header');
		util.transitionViz('community');
		util.showChapter('community');
		filters.toggle('community', -1);
	}

	if (chapter === 'aspirations') {
		util.changeHeader('.landing-header', '.main-header');
		util.transitionViz('aspirations');
		util.showChapter('aspirations');
		filters.toggle('aspirations', -1);
	}
}

function checkChapterChange(chapter) {
	const story_location = util.getStoryLocation();
	return chapter !== story_location.current_chapter;
}

export default {
	init,
	chapterChange
}